<template>
<!-- :sub-title='activePage.title' -->
<v-card flat>
  <!-- <v-card-title >
    {{productName}}
  </v-card-title> -->
  <v-card-text >
    <v-list dense dark >
      <practitioner-list-item v-if='practitioner' :item='practitioner' />
    </v-list>
    <request-status :request="request" />
    <data-form with-close
      v-on="$listeners"
      v-model='product'
      :fields='fields'
      :request='request'
      :trigger-save='saveFormToucher'
      :touch-clear='resetCount' >
    </data-form>
  </v-card-text>
</v-card>
</template>
<script>
import DataForm from '@/components/data/DataForm.vue'
import FormFieldsMixin from './forms/AppointmentTypeFormMixin'
import PractitionerListItem from '@/components/listitems/PractitionerListItem.vue'

import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  name: 'AppointmentTypeForm',
  components: {DataForm, PractitionerListItem},
  mixins: [FormFieldsMixin],
  props: {
    spaceId: { required: true },
    productId: { required: true }
  },
  data () {
    return {
      request: { resource: 'ag.spaces' },
      resetCount: 1,
      settings: {
        showExtraFields: true
      },
      saveFormToucher: 0
    }
  },
  watch: {
    productId: {
      immediate: true,
      handler () {
        this.resetCount++
        if (this.productId) {
          Vue.set(this.request, 'resourceId', this.spaceId)
          Vue.set(this.request, 'extra', 'appointment-types/' + this.productId)
          this.$request('get', this.request)
        }
      }
    },
    product () {
      if (this.product && this.product.id) {
        this.$emit('input', this.product)
      }
    },
    backgroundPicture () {
      if (this.backgroundPicture) {
        this.request.resourceId = this.spaceId
        this.request.data = {background_picture: this.backgroundPicture}
        this.$request('save', this.request)
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['getSpaceById', 'getPractitionerById']),
    space () {
      if (this.spaceId) {
        return this.getSpaceById(this.spaceId)
      }
      return {}
    },
    spaceName () {
      return this.getObjectPath(this.space, 'title', '')
    },
    product () {
      return this.getObjectPath(this.request, 'result', {})
    },
    productName () {
      return this.getObjectPath(this.product, 'title', '')
    },
    backgroundPicture () {
      return this.getObjectPath(this.product, 'background_picture', '')
    },
    practitionerId () {
      return this.getObjectPath(this.product, 'practitioner')
    },
    practitioner () {
      if (this.practitionerId) {
        return this.getPractitionerById(this.practitionerId, {})
      }
      return {}
    },
    basePath () {
      return `/settings/spaces/${this.spaceId}/appointment-type`
    },
    crumbs () {
      let crumbs = [
        {text: 'Home', to: '/'},
        {text: 'Spaces', to: '/settings/spaces', 'exact': true }
      ]
      if (this.space && this.space.id) {
        let item = { text: this.spaceName, to: this.basePath, 'exact': true }
        crumbs.push(item)
      }
      crumbs.push({text: this.productName, disabled: true})
      return crumbs
    }
  }
}
</script>
